import React from 'react';
import version from '../../../package.json';

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className='mt-auto shrink-0 bg-primary px-4 py-2 text-white shadow-inner sm:px-6 sm:py-3'>
      <div className='flex flex-col items-center justify-between gap-2 text-xs sm:flex-row'>
        <div className='font-bold'>Pulsalink Admin Dashboard v{version.version}</div>
        <div className='flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-center sm:justify-end'>
          <a
            href='mailto:support@pulsalink.id'
            className='opacity-80 transition-opacity hover:opacity-100'
          >
            Support
          </a>
          <span className='opacity-50'>·</span>
          <a
            href='https://pulsalink.id'
            target='_blank'
            rel='noreferrer'
            className='opacity-80 transition-opacity hover:opacity-100'
          >
            pulsalink.id
          </a>
          <span className='opacity-50'>·</span>
          <span className='opacity-80'>© {year} PT Belanja Pasti Indonesia</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
